import { useEffect, useRef } from "react";

export function useTypeOnce(text, speed, stepId, hasAnimatedRef, onComplete) {
  const elementRef = useRef(null);

  useEffect(() => {
    const el = elementRef.current;
    if (!el) return;

    // If already animated, just show text instantly
    if (hasAnimatedRef.current[stepId]) {
      el.textContent = text;
      if (onComplete) onComplete();
      return;
    }

    // Otherwise animate
    let index = 0;
    el.textContent = "";

    function type() {
      if (index < text.length) {
        el.textContent += text[index++];
        setTimeout(type, speed);
      } else {
        hasAnimatedRef.current[stepId] = true; // <-- mark as done
        if (onComplete) onComplete(); // <-- notify parent it’s done
      }
    }

    type();
  }, [text, speed, stepId, hasAnimatedRef]);

  return elementRef;
}
